/**
 * Product chrome defaults for Foundry CRM documents.
 * Tenant marketing/legal copy comes from Settings → Brand / Documents
 * (and onboarding). Do not put customer-facing org marketing here.
 */
export const PROPOSAL_BRAND = {
  companyName: '',
  legalName: '',
  registeredAddress: '',
  companyNumber: '',
  vatNumber: '',
  tagline: '',
  website: '',
  websiteLabel: '',
  /** Foundry CRM lockup for light surfaces. */
  logoSrc: '/assets/images/foundry-crm-logo.png',
  /** Foundry CRM lockup for dark proposal headers. */
  logoSrcOnDark: '/assets/images/foundry-crm-logo-reversed.png',
  /** Product attribution mark (sidebar “Powered by”). Not tenant company branding. */
  quantumFoundryLogoSrc: '/assets/images/quantum-foundry-logo.png',
  quantumFoundryLogoSrcOnDark: '/assets/images/quantum-foundry-logo-white.png',
  termsUrl: '',
  termsLabel: 'Terms and Conditions',
  privacyUrl: '',
  privacyLabel: 'Privacy Policy',
  navy800: '#12314D',
  navy900: '#0C2337',
  accent: '#2E7DD1',
  blue300: '#5DA3E8',
  blue100: '#E6F1FB',
  eyebrow: '',
  about: [] as string[],
  services: [] as Array<{ name: string; summary: string }>,
  trustedBy: [] as string[],
  closingNote: '',
} as const;
